import {CommonModule} from '@angular/common';
import {Component, inject} from '@angular/core';
import {NxSpinnerModule} from '@aposin/ng-aquila/spinner';
import {Observable} from 'rxjs';
import {LoaderService} from '../../services/loader/loader.service';

@Component({
    selector: 'fq-api-loader',
    imports: [CommonModule, NxSpinnerModule],
    templateUrl: './api-loader.component.html',
    styleUrl: './api-loader.component.scss'
})
export class ApiLoaderComponent {
  loaderService = inject(LoaderService);
  isLoading: Observable<boolean> = this.loaderService.getLoadingState$();
}
